import type { Language } from '../../../src/api/langConfig';
import type { Meal, Order } from '../types';
import { getCheckoutDayAllowedResult, type OrderDayDeadlineContext } from './orderDeadlines';

export type BasketCheckoutEntryInput = {
    date: string;
    draft: Order;
    placed: Order | null;
};

export type BasketCheckoutMenuContextByDate = Record<string, {
    ready: boolean;
    menuMealsForOrderDate?: Record<string, Meal> | null;
}>;

export type BasketCheckoutBlockedDay = {
    date: string;
    message: string;
};

export type BasketCheckoutValidityState = {
    /** True when every entry has a resolved menu snapshot for checkout rules. */
    ready: boolean;
    blocked: BasketCheckoutBlockedDay[];
};

/** Drawer / pre-pay preview — same rules as {@link assertCheckoutDayAllowed} on the server. */
export function evaluateBasketCheckoutValidity(
    entries: BasketCheckoutEntryInput[],
    menuContextByDate: BasketCheckoutMenuContextByDate,
    baseCtx: OrderDayDeadlineContext,
    lang: Language,
    at: Date,
): BasketCheckoutValidityState {
    const blocked: BasketCheckoutBlockedDay[] = [];

    for (const entry of entries) {
        const menuCtx = menuContextByDate[entry.date];
        if (!menuCtx?.ready) {
            return { ready: false, blocked: [] };
        }

        const deadlineCtx: OrderDayDeadlineContext = {
            ...baseCtx,
            menuMealsForOrderDate: menuCtx.menuMealsForOrderDate ?? null,
        };
        const result = getCheckoutDayAllowedResult(entry.date, entry.draft, entry.placed, deadlineCtx, lang, at);
        if (result.ok === false) {
            blocked.push({ date: entry.date, message: result.message });
        }
    }

    return { ready: true, blocked };
}
